import {
  DateSearchParams,
  FacilitySearchParams,
  BookingsListParams,
  UserSearchParams,
  SportSearchParams,
  EventSearchParams,
  TransactionSearchParams,
} from '../types/types';

export const baseUrl = process.env.REACT_APP_LOCAL_API + '/api';

export const urls = {
  sendOtp: '/Auth/otp/send',
  verifyOtp: '/Auth/otp/verify',
  createFacility: '/Facilities',
  createFacilityByAdmin: '/Facilities/admin',
  updateFacility: (facilityId: number) => `/Facilities/${facilityId}`,
  deleteFacility: (facilityId: number) => `/Facilities/${facilityId}`,
  getSportsByFacilityId: (facilityId: number) =>
    `/FacilitySports/${facilityId}/sports`,
  searchFacilities: (params?: FacilitySearchParams) =>
    `/Facilities/search${loadParams(params || {})}`,
  UpdateFacilityStatus: 'Facilities/status',
  searchUsers: (params?: UserSearchParams) =>
    `/Users/search${loadParams(params || {})}`,
  getFacilityById: (facilityid: number, withSports?: boolean) =>
    `/Facilities/${facilityid}${loadParams({ withSports })}`,
  getSports: '/Sports/lite',
  createFacilitySport: (facilityId: number) =>
    `/FacilitySports/${facilityId}/sports`,
  updateFacilitySport: (facilityId: number, sportId: number) =>
    `/FacilitySports/${facilityId}/sports/${sportId}`,
  deleteFacilitySport: (facilityId: number, sportId: number) =>
    `FacilitySports/${facilityId}/sports/${sportId}`,
  getSlotsByCourtId: (
    courtId: number,
    params?: DateSearchParams & { availableOnly?: boolean },
  ) => `Slots/court/${courtId}${loadParams(params || {})}`,
  createMultipleSlots: '/Slots/multiple',
  updateSlot: (slotId: number) => `/Slots/${slotId}`,
  deleteSlot: (slotId: number) => `/Slots/${slotId}`,
  updateCourt: (courtId: number) => `/FacilitySports/${courtId}/courts`,
  createMultipleCourts: (facilitySportId: number) =>
    `/FacilitySports/${facilitySportId}/courts/multiple`,
  deleteCourt: (facilitySportId: number, courtId: number) =>
    `FacilitySports/${facilitySportId}/courts/${courtId}`,
  bookings: (params?: BookingsListParams) =>
    `/Bookings/list${loadParams(params || {})}`,
  cancelBooking: (bookingId: number) => `/Bookings/${bookingId}/cancel`,
  uploadAttachment: '/Attachments/upload',
  bulkUploadAttachments: '/Attachments/bulk-upload',
  updateAttachment: (attachmentId: number) => `/Attachments/${attachmentId}`,
  deleteAttachment: (attachmentId: number) => `/Attachments/${attachmentId}`,
  getAttachmentByEntityId: (entityType: string, entityId: number) =>
    `/Attachments/${entityType}/${entityId}`,
  getAllSports: (params?: SportSearchParams) =>
    `/Sports${loadParams(params || {})}`,
  getSportById: (sportId: number) => `/Sports/${sportId}`,
  createSport: '/Sports',
  updateSport: (sportId: number) => `/Sports/${sportId}`,
  deactivateSport: (sportId: number) => `/Sports/${sportId}/deactivate`,
  deleteSport: (sportId: number) => `/Sports/${sportId}`,
  updatePrimaryAttachment: (facilityId: number, attachmentId: number) =>
    `Attachments/facilities/${facilityId}/primary-image/${attachmentId}`,
  deleteUser: (userId: number) => `/Users/${userId}`,
  createUser: '/Users/register',
  updateUser: (userId: number) => `/Users/profile/${userId}`,
  getUserById: (userId: number) => `/Users/profile/${userId}`,
  createUserAdmin: '/Users/admin/create-user',
  updateUserAdmin: (userId: number) =>
    `/Users/admin/update-user-profile/${userId}`,
  reserveSlots: '/Slots/reserve',
  unreserveSlots: '/Slots/release',
  searchEvents: (params?: EventSearchParams) =>
    `/Events/search${loadParams(params || {})}`,
  createEvent: '/Events/create-with-tournaments',
  updateEvent: (eventId: number) => `/Events/${eventId}`,
  getEventById: (eventId: number) => `/Events/${eventId}/dashboard`,
  getEventRecentRegistrations: (eventId: number) =>
    `/Events/${eventId}/recent-registrations`,
  createTournament: '/Tournaments',
  getPairedUnpairedParticipants: (tournamentId: number) =>
    `/Tournaments/${tournamentId}/participants/paired-unpaired`,
  generateBracket: (tournamentId: number) =>
    `/Tournaments/${tournamentId}/generate-bracket`,
  getTournamentBracket: (tournamentId: number) =>
    `/Tournaments/${tournamentId}/bracket`,
  updateTournament: (tournamentId: number) => `/Tournaments/${tournamentId}`,
  deleteTournament: (tournamentId: number) => `/Tournaments/${tournamentId}`,
  getTournamentTeams: (tournamentId: number) =>
    `/Tournaments/${tournamentId}/teams`,
  getTournamentMatchScore: (tournamentMatchId: number) =>
    `/Tournaments/matches/${tournamentMatchId}/score`,
  directUpdateTournamentParticipantScore: (tournamentMatchId: number) =>
    `/Tournaments/${tournamentMatchId}/update-score-direct`,
  declareWinner: (tournamentId: number, matchId: number) =>
    `/Tournaments/${tournamentId}/matches/${matchId}/result`,
  updateTournamentMatch: (tournamentMatchId: number) =>
    `/Tournaments/matches/${tournamentMatchId}`,
  getBookingDetails: (bookingId: number) => `/Bookings/${bookingId}`,
  cancelBookingSlot: (bookingId: number, slotId: number) =>
    `/Bookings/${bookingId}/slots/${slotId}/cancel`,
  searchTransactions: (params?: TransactionSearchParams) =>
    `/Transactions${loadParams(params || {})}`,
  eventsListLite: '/Events/list-lite',
  facilitiesListLite: '/Facilities/list-lite',
};

//Helper function to load query params
const loadParams = (params: object) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => searchParams.append(key, v.toString()));
      } else {
        searchParams.append(key, value.toString());
      }
    }
  });
  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : '';
};
